import React, { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import InboxIcon from '@mui/icons-material/Inbox';

type Props = {
  titel: string;
  hinweis?: string;
  aktion?: ReactNode;
};

/**
 * Hinweis für leere Listen. Ohne diesen sah eine leere Tabelle wie ein
 * Ladefehler aus – gerade wenn nur ein Filter zu eng gesetzt war.
 */
const LeerZustand = ({ titel, hinweis, aktion }: Props) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      gap: 1,
      py: 6,
      px: 2,
      color: 'text.secondary'
    }}
  >
    <InboxIcon sx={{ fontSize: 48, opacity: 0.4 }} />
    <Typography variant="subtitle1" color="text.primary">
      {titel}
    </Typography>
    {hinweis && (
      <Typography variant="body2" sx={{ maxWidth: 420 }}>
        {hinweis}
      </Typography>
    )}
    {aktion && <Box sx={{ mt: 1 }}>{aktion}</Box>}
  </Box>
);

export default LeerZustand;
